import { environment as base } from './environment.base';

export const environment = {
  ...base,
  code: 'smrt',
  dashboard: '',
  underlyingInvestmentsChartColors: [
  { key: 'Absolute Return Bond', value: '#12426F' },
  { key: 'Alternative Defensive', value: '#32608a' },
  { key: 'Alternative Growth', value: '#6a86ab' },
  { key: 'Alternatives - Defensive', value: '#32608a' },
  { key: 'Alternatives - Growth', value: '#6a86ab' },
  { key: 'Alternative Investments', value: '#008fb3' },
  { key: 'Australian Fixed Interest', value: '#02a2c2' },
  { key: 'Australian listed property securities', value: '#68bbd4' },
  { key: 'Australian Property Securities', value: '#231f20' },
  { key: 'Australian Shares', value: '#636366' },
  { key: 'Cash', value: '#939598' },
  { key: 'Cash and short-term fixed interest securities', value: '#47bbeb' },
  { key: 'Convertible Bonds', value: '#7ec9f0' },
  { key: 'Fixed Interest Securities', value: '#a9d9f4' },
  { key: 'Fixed Interest', value: '#a9d9f4' },
  { key: 'Global listed property', value: '#83c447' },
  { key: 'Global Property Securities', value: '#a3d072' },
  { key: 'Growth Fixed Income', value: '#bfdd9f' },
  { key: 'Infrastructure', value: '#0ea68a' },
  { key: 'International Fixed Interest', value: '#62b7a2' },
  { key: 'International Shares', value: '#83c3b2' },
  { key: 'International shares including emerging markets', value: '#f7981d' },
  { key: 'Listed Property', value: '#faaf56' },
],
  b2cPolicySignIn: 'B2C_1A_MP_SIGNUP_SIGNIN',
  b2cSignInAuthority:
    'https://apexproductdevelopment.b2clogin.com/apexproductdevelopment.onmicrosoft.com/B2C_1A_MP_SIGNUP_SIGNIN',

  b2cPolicyElevatedSignIn: 'B2C_1A_FP_MP_ELEVATEDACCESS',
  b2cElevatedSignInAuthority:
    'https://apexproductdevelopment.b2clogin.com/apexproductdevelopment.onmicrosoft.com/B2C_1A_FP_MP_ELEVATEDACCESS',

  b2cPolicyAdviserElevatedSignIn: 'B2C_1A_AP_MP_ELEVATEDACCESS',
  b2cAdviserElevatedSignInAuthority:
    'https://apexproductdevelopment.b2clogin.com/apexproductdevelopment.onmicrosoft.com/B2C_1A_AP_MP_ELEVATEDACCESS',

  b2cAuthorityDomain: 'apexproductdevelopment.b2clogin.com',
  b2cClientId: '87024527-32bc-4252-99ec-64dfc15c3d45',
  b2cReadScope:
    'https://ApexProductDevelopment.onmicrosoft.com/4aba6850-0b16-4ea9-9a2f-6ae62bb0d84c/MemberPortal.User',
  b2cWriteScope:
    'https://ApexProductDevelopment.onmicrosoft.com/4aba6850-0b16-4ea9-9a2f-6ae62bb0d84c/MemberPortal.User',
  postLogoutRedirectUri: '/',
  views: {
    ...base.views,
    historicalChart: {
      displayUnits: false,
    },
    insurance: {
      ...base.views.insurance,
      showEffectiveDate: true,
    },
    memberAlerts: {
      BindingNominationOfBeneficiaries: true,
    },
  },
};
